export function selectedList(List, param) {
    let selected
    List.forEach(element => {
        if (element.productName === param) {
            selected = element;
        }
    });
    return selected
}

export function disabled(param) {
    return (param.length === 0);
}

export const findCountry = (countryList, countryCode) => {
    let tempCountry;
    for (let i = 0; i < countryList.length; i++) {
        if (countryList[i].countryCode === countryCode) {
            tempCountry = countryList[i];
            break;
        }
    }
    return tempCountry;
}

/* export const setCountryInRequestBody = (selectedCounterparty) => {
    let tempCountry;
    if (!selectedCounterparty.country || selectedCounterparty.country.name === 'India') {
        tempCountry = {
            name: 'India',
            sortname: 'IN'
        }
    } else {
        tempCountry = {
            name: this.props.formValues.values.country.value,
            sortname: this.props.formValues.values.country.id
        }
    }
    return tempCountry
} */